export const _name = (item) => item.nameEn;

